<form autocomplete="off" novalidate [formGroup]="VodForm">
  <div class="main-content side-content pt-0 ml-0">
    <div class="main-container container-fluid">
      <div class="inner-body">
        <div class="row row-sm">
          <div class="col-lg-12">
            <div class="card custom-card">
              <div class="card-body pb-0">
                <div class="row">
                  <div class="col-md-7">
                    <div class="d-flex align-items-center pl-3">
                      <div>
                        <h3 class="main-content-label mb-1"><b>Verification of University Document</b></h3>
                        <p class="text-muted card-sub-title mb-0">
                          Submit your documents for verification
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="mt-2">
                
                <!-- Student Details -->
                <div class="row align-items-end">
                  <div class="col-sm-3">
                    <mat-form-field appearance="outline" class="example-full-width w-100">
                      <mat-label>Applicant's Full Name</mat-label>
                      <input formControlName="StuName" matInput readonly>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-3">
                    <mat-form-field appearance="outline" class="example-full-width w-100">
                      <mat-label>Course</mat-label>
                      <mat-select #courseSelect formControlName="StuCourse">
                        <mat-select-filter *ngIf="courseSelect.focused" [placeholder]="'Filter'"
                          [displayMember]="'CoName'" [array]="courseList"
                          (filteredReturn)="filteredCourseList = $event"></mat-select-filter>
                        <mat-option *ngFor="let item of filteredCourseList" [value]="item.CoCode">
                          {{item.CoName}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="VodForm.get('StuCourse')?.invalid && VodForm.get('StuCourse')?.touched">
                        Mandatory
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-3">
                    <mat-form-field appearance="outline" class="example-full-width w-100">
                      <mat-label>College</mat-label>
                      <mat-select #collegeSelect formControlName="StuClg">
                        <mat-select-filter *ngIf="collegeSelect.focused" [placeholder]="'Filter'"
                          [displayMember]="'CgName'" [array]="CollegeList"
                          (filteredReturn)="filteredCollegeList = $event"></mat-select-filter>
                        <mat-option *ngFor="let item of filteredCollegeList" [value]="item.CgCode">
                          {{item.CgName}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="VodForm.get('StuClg')?.invalid && VodForm.get('StuClg')?.touched">
                        Mandatory
                      </mat-error>
                    </mat-form-field>
                  </div>
                 <div class="col-sm-3 fs1">
                  <mat-form-field appearance="outline" class="example-full-width w-100">
                    <mat-label>PRN No.</mat-label>
                    <input formControlName="StuRgNo" matInput readonly>
                  </mat-form-field>
                </div>
                </div>

                <!-- Internship/Study Period -->
                <!-- <div class="row mt-3">
                  <div class="col-sm-3 fs1">
                    <p>Internship/Study Completion Period :</p>
                  </div>
                  <div class="col-sm-3 ml22">
                    <mat-form-field appearance="outline" class="calsz example-full-width w-100">
                      <mat-label>From Date</mat-label>
                      <input matInput [matDatepicker]="pickerFrom" formControlName="StuFromDate" [min]="minDate">
                      <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                      <mat-datepicker #pickerFrom></mat-datepicker>
                      <mat-error *ngIf="VodForm.get('StuFromDate')?.hasError('required') && VodForm.get('StuFromDate')?.touched">
                        Mandatory
                      </mat-error>
                      <mat-error *ngIf="VodForm.get('StuFromDate')?.hasError('invalidYear')">
                        Enter valid date
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-3">
                    <mat-form-field appearance="outline" class="calsz example-full-width w-100">
                      <mat-label>To Date</mat-label>
                      <input matInput [matDatepicker]="pickerTo" formControlName="StuToDate" [min]="minDate">
                      <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                      <mat-datepicker #pickerTo></mat-datepicker>
                      <mat-error *ngIf="VodForm.get('StuToDate')?.hasError('required') && VodForm.get('StuToDate')?.touched">
                        Mandatory
                      </mat-error>
                      <mat-error *ngIf="VodForm.get('StuToDate')?.hasError('dateMismatch')">
                        To Date must be greater than From Date
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div> -->

                <!-- Contact Details -->
                <div class="row mt-4">
                  <div class="col-sm-12">
                    <hr class="mb-3">
                    <p><strong>Contact Details</strong></p>
                  </div>
                  <div class="col-sm-3">
                    <mat-form-field appearance="outline" class="example-full-width w-100">
                      <mat-label>Phone Number</mat-label>
                      <input formControlName="StuPhone" matInput maxlength="10">
                    </mat-form-field>
                  </div>
                  <div class="col-sm-3">
                    <mat-form-field appearance="outline" class="example-full-width w-100">
                      <mat-label>Email</mat-label>
                      <input formControlName="StuEmail" matInput>
                      <mat-error *ngIf="VodForm.get('StuEmail')?.touched && VodForm.get('StuEmail')?.errors?.required">
                        Mandatory
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-4">
                    <mat-form-field appearance="outline" class="example-full-width w-100">
                      <mat-label>Address For Correspondence</mat-label>
                      <input formControlName="StuAdd" matInput>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-2">
                    <mat-form-field appearance="outline" class="example-full-width w-100">
                      <mat-label>PinCode</mat-label>
                      <input formControlName="StuPin" matInput maxlength="6">
                    </mat-form-field>
                  </div>
                </div>

                <!-- Delivery Information -->
                <div class="row mt-4">
                  <div class="col-sm-12">
                    <hr class="mb-3">
                    <p><strong>Delivery Information</strong></p>
                  </div>
                  <div class="col-sm-3">
                    <mat-form-field appearance="outline" class="example-full-width w-100">
                      <mat-label>Delivery option</mat-label>
                      <mat-select formControlName="DeliveryOpt">
                        <mat-option *ngFor="let item of deliveryList" [value]="item.dropdownValue">
                          {{item.Value}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="VodForm.get('DeliveryOpt')?.touched && VodForm.get('DeliveryOpt')?.errors?.required">
                        Mandatory
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-3" *ngIf="VodForm.get('DeliveryOpt')?.value === 'Soft' || VodForm.get('DeliveryOpt')?.value === 'Both'">
                    <mat-form-field appearance="outline" class="example-full-width w-100">
                      <mat-label>Email Id</mat-label>
                      <input formControlName="EmailId" matInput>
                      <mat-error *ngIf="VodForm.get('EmailId')?.touched && VodForm.get('EmailId')?.errors?.required">
                        Mandatory
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-2" *ngIf="VodForm.get('DeliveryOpt')?.value === 'Hard' || VodForm.get('DeliveryOpt')?.value === 'Both'">
                    <section class="example-section mt-2">
                      <mat-checkbox formControlName="isSameAddr" (change)="copyAddress($event)">Same as above</mat-checkbox>
                    </section>
                  </div>
                  <div class="col-sm-4" *ngIf="VodForm.get('DeliveryOpt')?.value === 'Hard' || VodForm.get('DeliveryOpt')?.value === 'Both'">
                    <mat-form-field appearance="outline" class="example-full-width w-100">
                      <mat-label>Postal Address</mat-label>
                      <input [readonly]="isreadonly" formControlName="PostalAdd" matInput>
                      <mat-error *ngIf="VodForm.get('PostalAdd')?.touched && VodForm.get('PostalAdd')?.errors?.required">
                        Mandatory
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-3" *ngIf="VodForm.get('DeliveryOpt')?.value === 'Hard' || VodForm.get('DeliveryOpt')?.value === 'Both'">
                    <mat-form-field appearance="outline" class="example-full-width w-100">
                      <mat-label>Delivery Location</mat-label>
                      <mat-select formControlName="DeliverAt">
                        <mat-option *ngFor="let item of deliveryOptionList" [value]="item.deliveryOptionValue">
                          {{item.Value}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="VodForm.get('DeliverAt')?.touched && VodForm.get('DeliverAt')?.errors?.required">
                        Mandatory
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <!-- Document Upload Section -->
                <div *ngIf="DocTable" class="mt-4">
                  <hr>
                  <p><strong>Documents To Upload</strong></p>
                  <div class="table-responsive">
                    <table class="table table-bordered text-nowrap text-left">
                      <thead>
                        <tr>
                          <th style="width: 40%">Document Name</th>
                          <th style="width: 40%">Document Upload</th>
                          <th style="width: 20%">View</th>
                        </tr>
                      </thead>
                      <tbody formArrayName="arrData">
                        <tr *ngFor="let row of VodForm.get('arrData')['controls']; let i = index" [formGroupName]="i">
                          <td>
                            <mat-form-field appearance="outline" class="example-full-width w-100">
                              <mat-label>Document Name</mat-label>
                              <input type="text" readonly formControlName="DocumentName" matInput>
                            </mat-form-field>
                          </td>
                          <td>
                            <div class="form-group mb-0">
                              <input type="hidden" formControlName="docFile">
                              <input type="file" 
                                     accept=".pdf"
                                     (change)="onFileSelected($event, i)" 
                                     class="form-control-file">
                              <div *ngIf="row.get('DocumentFile')?.touched && row.get('DocumentFile')?.errors?.required" class="text-danger small">
                                Mandatory
                              </div>
                            </div>
                          </td>
                          <td class="text-center">
                            <a (click)="showbase64(fileUploads[i] ? fileUploads[i] : row.get('DocumentFile')?.value)" class="blue_col cursor-pointer">View</a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="clearfix"></div>
                <div class="mt-3 text-right">
                  <button type="button" class="btn btn-primary btn-icon-text mr-2" (click)="Back()">
                    <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 5px;"> Back
                  </button>
                  <button *ngIf="SaveBtn" type="button" (click)="Save()" [disabled]="SaveDisabled"
                    class="btn btn-primary btn-icon-text">
                    <img width="20vh" src="../../assets/images/save.gif" style="margin-right: 5px;"> Save
                  </button>
                  <button *ngIf="UpdateBtn" type="button" (click)="Update()" [disabled]="UpdateDisabled"
                    class="btn btn-primary btn-icon-text">
                    <img width="20vh" src="../../assets/images/save.gif" style="margin-right: 5px;"> Update
                  </button>
                  <button *ngIf="PayFee" type="button" (click)="PayFees()" [disabled]="PayDisabled"
                    class="btn btn-primary btn-icon-text mr-2">
                    <img width="20vh" src="../../assets/images/pay-per-click.gif" style="margin-right: 5px;"> Pay
                  </button>
                  <button *ngIf="PayRecpt" type="button" (click)="getFeeTempData()"
                    class="btn btn-primary pay btn-icon-text">
                    <img width="20vh" src="../../assets/images/pay-per-click.gif" style="margin-right: 5px;"> Payment Receipt
                  </button>
                </div>

              
                <!-- Status Table -->
                  <div *ngIf="Table" class="table-responsive table-container tab mt-3">
                    <table class="table table-bordered text-nowrap text-left">
                      <thead>
                        <tr>
                          <th>Id</th>
                          <th>Request Type</th>
                          <th>Course Name</th>
                          <th>Fee Status</th>
                          <th>Comment</th>
                          <th>Status</th>
                          <th *ngIf="AdminUpload.length > 0">Certificate</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let tclc of TclcData">
                          <td>{{ tclc.TclcId }}</td>
                          <td>Verification of University Document</td>
                          <td>{{ tclc.CoName }}</td>
                          <td>{{ tclc.FeeStatus == 'Y' ? 'Paid' : 'Not Paid' }}</td>
                          <td>{{ tclc.Comment && tclc.Comment.trim() !== '' ? tclc.Comment : '-' }}</td>
                          <td>{{ Status ? Status : '-' }}</td>
                          <td *ngIf="AdminUpload.length > 0" class="text-center">
                            <img alt="Download"
                                (click)="downloadCertificate()"
                                src="../../assets/images/arrow (1).png"
                                class="cursor-pointer"
                                style="height: 30px;">
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>